export default __webpack_public_path__ + "static/winter36-2bbe348b61ccfa8382e8c8dc31e2853f.webp";